import { type FC, type ReactNode } from 'react'

import { ProductDescriptionParsedField } from '../ProductDescriptionParsedField'

export interface ProductDescriptionSectionType {
  content: string
  expandedByDefault?: boolean
  header: ReactNode
  showCautions?: boolean
}

interface ProductDescriptionSectionProps {
  section: ProductDescriptionSectionType
}

export const ProductDescriptionSection: FC<ProductDescriptionSectionProps> = ({
  section,
}) => {
  return (
    <>
      {section.header ? (
        <h3 className="mb-2.5 text-m font-medium">
          {/* eslint-disable-next-line react/jsx-no-literals -- the rule was disabled before a comment became required */}
          {section.header}:
        </h3>
      ) : null}
      <ProductDescriptionParsedField
        className="last:mb-0"
        field={section.content}
      />
    </>
  )
}
